import { buttonsFromSerializedInAppMessage as ye } from "../in-app-message-factory.js";
import InAppMessage from "./in-app-message.js";
export default class FullScreenMessage extends InAppMessage {
  constructor(
    e,
    r,
    s,
    t,
    i,
    a,
    o,
    p,
    m,
    n,
    u,
    c,
    f,
    d,
    l,
    g,
    j,
    x,
    z,
    h,
    v,
    w,
    y,
    S,
    b,
    k,
    q,
    A,
    B,
    C,
    D,
  ) {
    (p = p || InAppMessage.DismissType.MANUAL),
      (k = k || InAppMessage.Orientation.PORTRAIT),
      super(
        e,
        r,
        void 0,
        s,
        t,
        i,
        a,
        o,
        p,
        m,
        n,
        u,
        c,
        f,
        d,
        l,
        g,
        j,
        x,
        z,
        h,
        v,
        w,
        y,
        S,
        (b = b || InAppMessage.CropType.CENTER_CROP),
        k,
        q,
        A,
        B,
        C,
        D,
      ),
      (this.Io = InAppMessage.TextAlignment.CENTER);
  }
  gt() {
    return super.gt(FullScreenMessage.es);
  }
  static Zn(e) {
    return new FullScreenMessage(
      e[InAppMessage.ss.pa],
      e[InAppMessage.ss.ma],
      e[InAppMessage.ss.xs],
      e[InAppMessage.ss.ua],
      e[InAppMessage.ss.ca],
      e[InAppMessage.ss.URI],
      e[InAppMessage.ss.fa],
      e[InAppMessage.ss.da],
      e[InAppMessage.ss.la],
      e[InAppMessage.ss.ga],
      e[InAppMessage.ss.ns],
      e[InAppMessage.ss.ja],
      e[InAppMessage.ss.xa],
      e[InAppMessage.ss.za],
      e[InAppMessage.ss.ha],
      e[InAppMessage.ss.va],
      e[InAppMessage.ss.wa],
      e[InAppMessage.ss.ya],
      e[InAppMessage.ss.Sa],
      e[InAppMessage.ss.ba],
      e[InAppMessage.ss.ka],
      e[InAppMessage.ss.qa],
      e[InAppMessage.ss.Aa],
      ye(e[InAppMessage.ss.Ba]),
      e[InAppMessage.ss.Ca],
      e[InAppMessage.ss.Da],
      e[InAppMessage.ss.Ea],
      e[InAppMessage.ss.CSS],
      e[InAppMessage.ss.Fa],
      e[InAppMessage.ss.LANGUAGE],
      e[InAppMessage.ss.ks],
    );
  }
}
FullScreenMessage.es = InAppMessage.Eo.Yn;
